import { IWpData } from '../types';

declare global {
  interface Window {
    wpData: IWpData;
  }
}

export const wpData = window.wpData ?? {
  ajaxUrl: 'http://localhost:10154/wp-admin/admin-ajax.php',
  restUrl: 'http://localhost:10154/wp-json/location-finder',
  mapAPIKey: 'AIzaSyD3obtrtJxIt0MA4p6FBKZljPiUIhf9Niw'
};
